import { createFileRoute, Link } from "@tanstack/react-router";
import { PageShell, PageHero } from "@/components/site/page-shell";
import { CTABanner } from "@/components/sections/cta-banner";
import { Handshake, Users, Server, Code, DollarSign, Award } from "lucide-react";

export const Route = createFileRoute("/partners")({
  component: PartnersPage,
  head: () => ({
    meta: [
      { title: "Partner Program — CoderLity" },
      { name: "description", content: "Become a CoderLity partner — agency, reseller, hosting, software or referral partnerships with generous commissions." },
      { property: "og:title", content: "Partner Program — CoderLity" },
      { property: "og:description", content: "Grow together — agency, reseller, hosting, software and referral partnerships." },
      { property: "og:url", content: "/partners" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/partners" }],
  }),
});

const tracks = [
  { icon: Users, title: "Agency Partners", body: "White-label our development, hosting and marketing services under your brand." },
  { icon: Server, title: "Reseller Partners", body: "Resell hosting, domains and SaaS with wholesale pricing and dedicated support." },
  { icon: Handshake, title: "Referral Partners", body: "Refer clients and earn 20% recurring commission for 12 months." },
  { icon: Code, title: "Software Partners", body: "Integrate your product with our platforms and reach thousands of customers." },
  { icon: DollarSign, title: "Affiliate Partners", body: "Promote CoderLity via content, YouTube or newsletters — get paid per sale." },
  { icon: Award, title: "Solution Partners", body: "Certified implementation partners for ERP, POS, CRM and hosting rollouts." },
];

function PartnersPage() {
  return (
    <PageShell>
      <PageHero
        eyebrow="Partners"
        title="Grow with CoderLity"
        sub="Agencies, resellers, hosts and creators — pick the partnership that fits and start earning."
      />

      <section className="py-16">
        <div className="mx-auto max-w-7xl px-4 lg:px-8">
          <h2 className="text-3xl font-bold tracking-tight">Partnership tracks</h2>
          <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {tracks.map((t) => (
              <div key={t.title} className="rounded-2xl border border-border bg-card p-6 hover:border-primary/40 transition">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-brand text-white shadow-glow">
                  <t.icon className="h-5 w-5" />
                </span>
                <h3 className="mt-4 text-lg font-semibold">{t.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground">{t.body}</p>
              </div>
            ))}
          </div>
          <div className="mt-10 text-center">
            <Link to="/contact" className="inline-flex items-center rounded-full bg-gradient-brand px-6 py-3 text-sm font-semibold text-white shadow-glow">
              Apply to partner program
            </Link>
          </div>
        </div>
      </section>

      <CTABanner />
    </PageShell>
  );
}
